"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_pfeil_suedost = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_pfeil_suedost = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC3SURBVFhH7ZaxDYMwEEUNaVgjWzBCtkhGYAT2yQApswhS0qVOlRL+B1uKkB0w4KPIPenJZwTiQYEwivL3HOzqo4BX+IYND0jCm99gCz/wBMWpIQM0QiMcSyIukNdV/W4DYiPukOc++t1GxEQkCSBzI5IFkDkRSQPIVETyAPIrQiSAhCLEAogvQjSAjCNedhYLIN8RzmBAZtcY+Hk9D2OQEvKfwvGEx2Fcj+8Jpwy+gdyuiqLshDEduK5nPS8Gl1IAAAAASUVORK5CYII=",
    iconSize: [32, 32],
});
